import Vue from 'vue'
import ElementUI from 'element-ui'
import LayoutComponents from '../packages/layout-components/src/index.js'
import App from './App.vue'
import router from './router'
import './styles/index.scss'

Vue.use(ElementUI)
Vue.use(LayoutComponents)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')



